import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5BC2F4",
      d: "M7 .125c-3.883 0-7 2.543-7 5.688 0 1.34.602 2.597 1.559 3.554C1.23 10.762.082 11.992.082 11.992c-.082.055-.082.164-.055.246s.11.137.192.137c1.832 0 3.144-.875 3.855-1.422.903.328 1.887.547 2.926.547 3.883 0 6.973-2.57 6.973-5.687S10.855.125 7 .125M7.219 8H4.156a.63.63 0 0 1-.656-.656c0-.356.273-.657.656-.657H7.22c.355 0 .656.301.656.657 0 .383-.3.656-.656.656m2.625-2.625H4.156a.63.63 0 0 1-.656-.656c0-.356.273-.657.656-.657h5.688c.355 0 .656.301.656.657 0 .383-.3.656-.656.656"
    }, null, -1)
  ])))
}
export default { render: render }